import React from 'react';
import { SystemMessageTypes, SystemMessages } from '../systemMessages';
import useTranslation from '../../../../../hooks/use-translation';
export const SystemMessageButton = ({ messageType, isSender, message }) => {
    const { translate } = useTranslation();
    const systemMessageType = Object.values(SystemMessageTypes).find((type) => type === messageType);
    if (!systemMessageType)
        return React.createElement(React.Fragment, null);
    if (!SystemMessages[messageType].hasButtonSender && !SystemMessages[messageType].hasButtonReceiver)
        return React.createElement(React.Fragment, null);
    if (isSender && !SystemMessages[messageType].hasButtonSender)
        return React.createElement(React.Fragment, null);
    if (!isSender && !SystemMessages[messageType].hasButtonReceiver)
        return React.createElement(React.Fragment, null);
    return (React.createElement("button", { className: 'mt-3 btn btn-primary btn-md fw-bold fs-4', onClick: () => SystemMessages[messageType].action(message) }, translate(SystemMessages[messageType].hasButtonSender ? SystemMessages[messageType].buttonText_sender_id : SystemMessages[messageType].buttonText_receiver_id)));
};
